import React from "react";
import { withTranslation } from "react-i18next";
import configData from "../../../temp/config";

const DiaperSizeCalculatorResult = (props) => {
  let domain = configData.sitecoreApiHost;
  let errorResponseText = props.diaperCalculatorData.apiData.errorResponseText;
  const { t } = props; // for dictionary phrases
  let resultTripTitleStr = t(
    "DiaperSizeCalculator_TripEventResultTitle"
  ).replace(
    "{totalPackages}",
    props.diaperCalculatorData.apiData.diapersPerTrip
  );
  let resultDiaperPerDayTitleStr = t(
    "DiaperSizeCalculator_PerDayEventResultTitle"
  ).replace(
    "{totalPackages}",
    props.diaperCalculatorData.apiData.diapersPerDay
  );

  const Result = () => {
    if (props.diaperCalculatorData.eventType === "Predict Diaper Size") {
      return (
        <div className="results-block">
          <div className="results-head">
            <div className="text-center">
              <h3 className="text-brand-recommended">
                {t("DiaperSizeCalculator_Recommended")}
              </h3>
              <div className="brand-image">
                {props.diaperCalculatorData.apiData.productImage != null && (
                  <img
                    src={
                      domain +
                      props.diaperCalculatorData.apiData.productImage.src
                    }
                    alt=""
                    srcSet=""
                    loading="lazy"
                  />
                )}
              </div>
              <h1>{props.diaperCalculatorData.apiData.brandName}</h1>
              <p className="text-brand-size">
                {props.diaperCalculatorData.apiData.diaperSize}
              </p>
            </div>
          </div>
        </div>
      );
    } else if (props.diaperCalculatorData.eventType === "Diaper Per Day") {
      return (
        <div className="results-block">
          <div className="results-head">
            <div className="text-center">
              <h3 className="text-brand-recommended">
                {t("DiaperSizeCalculator_Recommended")}
              </h3>
              <div className="brand-image">
                {props.diaperCalculatorData.apiData.productImage != null && (
                  <img
                    src={
                      domain +
                      props.diaperCalculatorData.apiData.productImage.src
                    }
                    alt=""
                    srcSet=""
                    loading="lazy"
                  />
                )}
              </div>
              <h1>{props.diaperCalculatorData.apiData.brandName}</h1>
              <p className="text-brand-size">
                {props.diaperCalculatorData.apiData.diaperSize}
              </p>
              <h3 className="text-brand-description">
                {t("DiaperSizeCalculator_ResultPreText")}
              </h3>
              <p>{resultDiaperPerDayTitleStr}</p>
            </div>
          </div>
        </div>
      );
    } else if (props.diaperCalculatorData.eventType === "Diaper For Trip") {
      return (
        <div className="results-block">
          <div className="results-head">
            <div className="text-center">
              <h3 className="text-brand-recommended">
                {t("DiaperSizeCalculator_Recommended")}
              </h3>
              <div className="brand-image">
                {props.diaperCalculatorData.apiData.productImage != null && (
                  <img
                    src={
                      domain +
                      props.diaperCalculatorData.apiData.productImage.src
                    }
                    alt=""
                    srcSet=""
                    loading="lazy"
                  />
                )}
              </div>
              <h1>{props.diaperCalculatorData.apiData.brandName}</h1>
              <p className="text-brand-size">
                {props.diaperCalculatorData.apiData.diaperSize}
              </p>
              <h3 className="text-brand-description">
                {t("DiaperSizeCalculator_ResultPreText")}
              </h3>
              <p>{resultTripTitleStr}</p>
            </div>
          </div>
        </div>
      );
    }
  };
  return (
    <>
      {props != null && errorResponseText === "" && <Result />}
      {errorResponseText !== "" && (
        <div className="results-block">
          <div className="results-head">
            <div className="content">
              <p>{props.diaperCalculatorData.apiData.errorResponseText}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withTranslation()(DiaperSizeCalculatorResult);
